import { find } from "@suse-o11y/find";
import { pipe } from "@suse-o11y/pipe";
import { prop } from "@suse-o11y/prop";
import { sortBy } from "@suse-o11y/sort-by";

export interface ChartThresholdStep {
	color: string;
	value: number;
}

export type ChartThresholds = [defaultColor: string, ...steps: ReadonlyArray<ChartThresholdStep>];

export function findChartThresholdColor(value: undefined | number, [defaultColor, ...steps]: ChartThresholds): string {
	if (value == null) {
		return defaultColor;
	}

	const correspondingStep = pipe(
		steps,
		sortBy([prop("value"), "desc"]),
		find((step) => step.value <= value),
	);

	return correspondingStep ? correspondingStep.color : defaultColor;
}
